"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportProductStatus = exports.ImportProductStaticKey = exports.IMPORT_ENTITY_DIRECTORY_PATH = exports.IMPORT_ENTITY_TYPE = exports.ImportErrorType = exports.IMPORT_JOB_STATUS = void 0;
var IMPORT_JOB_STATUS;
(function (IMPORT_JOB_STATUS) {
    IMPORT_JOB_STATUS["VALIDATING"] = "VALIDATING";
    IMPORT_JOB_STATUS["RUNNING"] = "RUNNING";
    IMPORT_JOB_STATUS["FAILED"] = "FAILED";
    IMPORT_JOB_STATUS["COMPLETED"] = "COMPLETED";
    IMPORT_JOB_STATUS["CANCELLED"] = "CANCELLED";
})(IMPORT_JOB_STATUS = exports.IMPORT_JOB_STATUS || (exports.IMPORT_JOB_STATUS = {}));
var ImportErrorType;
(function (ImportErrorType) {
    ImportErrorType["MISSING_REQUIRED_FIELD"] = "MISSING_REQUIRED_FIELD";
    ImportErrorType["ENTITIES_NOT_FOUND"] = "ENTITIES_NOT_FOUND";
    ImportErrorType["INVALID_DATA_FORMAT"] = "INVALID_DATA_FORMAT";
    ImportErrorType["INVALID_BOOLEAN_VALUE"] = "INVALID_BOOLEAN_VALUE";
    ImportErrorType["NEGATIVE_PRICE"] = "NEGATIVE_PRICE";
    ImportErrorType["UNKNOWN_ATTRIBUTE_VALUE"] = "UNKNOWN_ATTRIBUTE_VALUE";
    ImportErrorType["INVALID_PRODUCT_TYPE"] = "INVALID_PRODUCT_TYPE";
    ImportErrorType["DUPLICATE_IN_FILE"] = "DUPLICATE_IN_FILE";
    ImportErrorType["PRODUCT_NOT_IDENTIFIED"] = "PRODUCT_NOT_IDENTIFIED";
    ImportErrorType["HIERARCHY_NOT_FOUND"] = "HIERARCHY_NOT_FOUND";
    ImportErrorType["OTHER"] = "OTHER";
})(ImportErrorType = exports.ImportErrorType || (exports.ImportErrorType = {}));
var IMPORT_ENTITY_TYPE;
(function (IMPORT_ENTITY_TYPE) {
    IMPORT_ENTITY_TYPE["PRODUCT"] = "PRODUCT";
    IMPORT_ENTITY_TYPE["METADATA"] = "METADATA";
})(IMPORT_ENTITY_TYPE = exports.IMPORT_ENTITY_TYPE || (exports.IMPORT_ENTITY_TYPE = {}));
var IMPORT_ENTITY_DIRECTORY_PATH;
(function (IMPORT_ENTITY_DIRECTORY_PATH) {
    IMPORT_ENTITY_DIRECTORY_PATH["PRODUCT"] = "import/product";
    IMPORT_ENTITY_DIRECTORY_PATH["TEMPLATE"] = "import/template";
})(IMPORT_ENTITY_DIRECTORY_PATH = exports.IMPORT_ENTITY_DIRECTORY_PATH || (exports.IMPORT_ENTITY_DIRECTORY_PATH = {}));
// This enum is used to map the column names in the import file to a static keys
var ImportProductStaticKey;
(function (ImportProductStaticKey) {
    ImportProductStaticKey["productId"] = "productId";
    ImportProductStaticKey["productName"] = "productName";
    ImportProductStaticKey["productType"] = "productType";
    ImportProductStaticKey["productGroup"] = "productGroup";
    ImportProductStaticKey["reportingGroup"] = "reportingGroup";
    ImportProductStaticKey["category"] = "category";
    ImportProductStaticKey["variantGroup"] = "variantGroup";
    ImportProductStaticKey["variantName"] = "variantName";
    ImportProductStaticKey["measuredBy"] = "measuredBy";
    ImportProductStaticKey["defaultValue"] = "defaultValue";
    ImportProductStaticKey["unit"] = "unit";
    ImportProductStaticKey["posName"] = "posName";
    ImportProductStaticKey["kitchenName"] = "kitchenName";
    ImportProductStaticKey["printerProfiles"] = "printerProfiles";
    ImportProductStaticKey["description"] = "description";
    ImportProductStaticKey["isSellable"] = "isSellable";
    ImportProductStaticKey["printOnReceipt"] = "printOnReceipt";
    ImportProductStaticKey["dietaryTags"] = "dietaryTags";
    ImportProductStaticKey["allergens"] = "allergens";
    ImportProductStaticKey["nutrient"] = "nutrient";
    ImportProductStaticKey["avgQtyServing"] = "avgQtyServing";
    ImportProductStaticKey["availableLocations"] = "availableLocations";
    ImportProductStaticKey["costPerLocation"] = "costPerLocation";
    ImportProductStaticKey["costPrice"] = "costPrice";
    ImportProductStaticKey["costTax"] = "costTax";
    ImportProductStaticKey["barcode"] = "barcode";
    ImportProductStaticKey["sku"] = "sku";
    ImportProductStaticKey["plu"] = "plu";
    ImportProductStaticKey["gtin"] = "gtin";
    ImportProductStaticKey["sellingPrice"] = "sellingPrice";
    ImportProductStaticKey["sellingTax"] = "sellingTax";
    ImportProductStaticKey["recipe"] = "recipe";
    ImportProductStaticKey["variablePricing"] = "variablePricing";
    ImportProductStaticKey["minSellingPrice"] = "minSellingPrice";
    ImportProductStaticKey["maxSellingPrice"] = "maxSellingPrice";
    ImportProductStaticKey["imageUrl"] = "imageUrl";
})(ImportProductStaticKey = exports.ImportProductStaticKey || (exports.ImportProductStaticKey = {}));
var ImportProductStatus;
(function (ImportProductStatus) {
    ImportProductStatus["NEW"] = "NEW";
    ImportProductStatus["EXISTING"] = "EXISTING";
    ImportProductStatus["ERROR"] = "ERROR";
})(ImportProductStatus = exports.ImportProductStatus || (exports.ImportProductStatus = {}));
//# sourceMappingURL=importEntity.js.map